export default __webpack_public_path__ + "static/media/tamara_wiesen.5d65f5bf.jpeg";